<template>
  <div class="BlockList">
    <div class="BlockList-W">
      <div class="productbox">
        <div class="productleft">
          <img src="../../../assets/pc/Admin/logo.png" />
        </div>
        <div class="productright">
          <div class="login">You are logged in</div>
          <div class="titbox">
            <div class="titleft">Investment products</div>
            <div class="titright" @click="addproduct">Add new product</div>
          </div>
          <div class="titcontent">
            <div class="tabheader">
              <div>Product name</div>
              <div>Investment target</div>
              <div>Total earnings</div>
              <div>Total return rate</div>
              <div>Fund pool</div>
              <div>Creation time</div>
              <div>Action</div>
            </div>
            <div class="tabcontent">
              <ul>
                <li v-for="(item, index) in list" :key="index">
                  <div>{{ item.productName }}</div>
                  <div>{{ item.markNameStr }}</div>
                  <div>{{ item.totalProfit }} U</div>
                  <div>{{ item.totalProfitRate }}%</div>
                  <div>{{ item.fundAmount }} U</div>
                  <div>{{ item.createTime }}</div>
                  <div class="detail">
                    <div class="datailtit" @click="Details(index)">Details</div>
                    <img
                      @click="deletes(item.productId)"
                      src="../../../assets/pc/Admin/delete.png"
                    />
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div class="pagination">
            <el-pagination
              background
              small
              :current-page.sync="pageNum"
              :page-size="10"
              :pager-count="5"
              layout="prev, jumper, next"
              @current-change="CurrentChange"
              :total="total"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <div class="BlockListdelt" v-show="dflog">
      <div class="BlockListdelt-W">
        <div class="dtit">Are you sure you want to delete?</div>
        <div class="dcon">
          <div class="close" @click="dclose">Close</div>
          <div class="ok" @click="dok">OK</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  GetLogin,
  GetgetProductList,
  GetremoveProduct,
} from "@/assets/server/api";
import { timestampConvertTime } from "@/utils/utils";
export default {
  props: ["flog", "flogb"],
  data() {
    return {
      dflog: false,
      list: [],
      value: "",
      pageNum: 1,
      total: null,
      form: {
        email: "",
        password: "",
      },
      rules: {
        email: [
          {
            required: true,
            message: "email  is required",
            trigger: "change",
          },
          {
            type: "email",
            message: "Please enter a valid email address",
            trigger: ["blur", "change"],
          },
        ],
      },
    };
  },
  components: {},
  created() {},
  mounted() {
    this.getproductlists();
  },
  watch: {
    deep: true,

    flog(val) {
      this.floag = val;
    },
    flogb(val) {
     // console.log(val);
      this.floagb = val;
    },
  },
  methods: {
    dclose() {
      this.dflog = false;
    },
    async deletes(id) {
      this.dflog = true;
      let formData = new FormData();
      let params = {
        productId: id,
      };
      let item = params;
      for (const key in item) {
        if (Object.hasOwnProperty.call(item, key)) {
          formData.append(key, item[key]);
        }
      }
      var res = await GetremoveProduct(formData);
     // console.log(res);
      // if(res.code==200){
      //   this.dflog=false;
      // }
    },
    dok() {
      this.dflog = false;
      this.getproductlists();
    },
    formattedDate(val) {
      const date = new Date(val);
      return date.toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    },
    CurrentChange(val) {
      this.pageNum = val;
      this.getproductlists();
    },
    Details(index) {
      let params = {
        productId: this.list[index].productId,
      };
      this.$router.push({ path: "/pc/Details", query: params });
      // this.$router.push("/pc/Details");
    },
    addproduct() {
      this.$router.push("/pc/AddProduct");
    },
    async getproductlists() {
      let formData = new FormData();

      let params = {
        pageNum: this.pageNum,
        pageSize: 10,
      };
      let item = params;
      for (const key in item) {
        if (Object.hasOwnProperty.call(item, key)) {
          formData.append(key, item[key]);
        }
      }
      var res = await GetgetProductList(formData);
    //  console.log(res);
      this.total = res.result.count;
     // console.log(this.total);
      this.list = res.result.list;
    //  console.log(this.list);
      for (var i = 0; i < this.list.length; i++) {
        this.list[i].createTime = timestampConvertTime(this.list[i].createTime);
      }
    },
  },
};
</script>
<style lang="less">
/deep/.el-message {
  z-index: 99999999999 !important;
  background-color: #fff !important;
  /* 设置文本颜色为白色 */
  color: white !important;

  /* 其他样式调整，根据需要自行添加 */
}
</style>
<style lang="less" scoped>
.BlockList {
  background: #000;
  width: 100%;
  height: 100%;
  margin: 0 auto;
  overflow: auto;

  .BlockList-W {
    width: 1440px;
    margin: 0 auto;
    min-height: 900px;
    background: #161920;
    border-radius: 0px 0px 0px 0px;
    .productbox {
      display: flex;
      .productleft {
        width: 120px;
        height: 900px;
        background: #0c1119;
        border-radius: 0px 0px 0px 0px;
        img {
          width: 44px;
          height: 44px;
          margin-top: 15px;
          margin-left: 38px;
        }
      }
      .productright {
        width: 1320px;
        background: #161920;
        .login {
          font-family: Alibaba PuHuiTi 3, Alibaba PuHuiTi 30;
          font-weight: 500;
          font-size: 18px;
          color: rgba(255, 255, 255, 0.6);
          margin-top: 24px;
          margin-left: 40px;
        }
        .titbox {
          display: flex;
          justify-content: space-between;
          width: 1280px;

          height: 80px;
          line-height: 80px;
          border-radius: 6px;
          background: linear-gradient(
            99deg,
            #262932 0%,
            rgba(33, 38, 49, 0) 100%
          );
          border: 1px solid rgba(255, 255, 255, 0.1);
          margin: 0 auto;
          margin-top: 23px;
          .titleft {
            font-family: Alibaba PuHuiTi 3, Alibaba PuHuiTi 30;
            font-weight: 900;
            font-size: 28px;
            color: #3cf6f0;
            margin-left: 20px;
          }
          .titright {
            width: 177px;
            height: 39px;
            line-height: 39px;
            background: #252932;
            border-radius: 5px 5px 5px 5px;
            border: 1px solid #464a52;
            margin-right: 20px;
            text-align: center;
            margin-top: 20px;
            font-family: Alibaba PuHuiTi 3, Alibaba PuHuiTi 30;
            font-weight: 500;
            font-size: 18px;
            color: #ffffff;
            cursor: pointer;
          }
        }
        .titcontent {
          width: 1280px;
          margin: 0 auto;
          .tabheader {
            display: flex;
            div {
              font-family: Alibaba PuHuiTi 3, Alibaba PuHuiTi 30;
              font-weight: 500;
              font-size: 14px;
              color: rgba(255, 255, 255, 0.4);
              height: 70px;
              line-height: 70px;
            }
            div:nth-child(1) {
              width: 10%;
              padding-left: 20px;
            }
            div:nth-child(2) {
              width: 40%;
            }
            div:nth-child(3) {
              width: 10%;
              text-align: center;
            }
            div:nth-child(4) {
              width: 10%;
              text-align: center;
            }
            div:nth-child(5) {
              width: 10%;
              text-align: center;
            }
            div:nth-child(6) {
              width: 10%;
              text-align: center;
            }
            div:nth-child(7) {
              width: 10%;
              text-align: right;
              padding-right: 20px;
            }
          }
          .tabcontent {
            width: 1280px;
            margin: 0 auto;
            ul {
              li {
                display: flex;
                font-family: Alibaba PuHuiTi 3, Alibaba PuHuiTi 30;
                font-weight: 400;
                font-size: 16px;
                color: #ffffff;
                div:nth-child(1) {
                  width: 10%;
                  padding-left: 20px;
                }
                div:nth-child(2) {
                  width: 40%;
                }
                div:nth-child(3) {
                  width: 10%;
                  text-align: center;
                }
                div:nth-child(4) {
                  width: 10%;
                  text-align: center;
                }
                div:nth-child(5) {
                  width: 10%;
                  text-align: center;
                }
                div:nth-child(6) {
                  width: 10%;
                  text-align: center;
                }
                div:nth-child(7) {
                  width: 10%;
                  text-align: right;
                }
                .detail {
                  display: flex;
                  padding-right: 20px;
                  .datailtit {
                    width: 130px;
                    text-align: right;
                    font-family: Alibaba PuHuiTi 3, Alibaba PuHuiTi 30;
                    font-weight: 400;
                    font-size: 16px;
                    color: #3efff9;
                    cursor: pointer;
                    padding-right: 20px;
                  }
                  img {
                    width: 25px;
                    height: 25px;
                    margin-top: 16px;
                    cursor: pointer;
                  }
                }
              }
              li:hover {
                width: 1280px;
                height: 60px;
                line-height: 60px;
                background: linear-gradient(
                  90deg,
                  rgba(60, 246, 240, 0.2) 5%,
                  rgba(60, 246, 240, 0) 100%
                );
                border: 1px solid;
                border-image: linear-gradient(
                    270deg,
                    rgba(
                      60.00000022351742,
                      246.0000005364418,
                      240.00000089406967,
                      0.5
                    ),
                    rgba(
                      60.00000022351742,
                      246.0000005364418,
                      240.00000089406967,
                      0
                    )
                  )
                  1 1;
              }
              li:nth-child(even) {
                width: 1280px;
                height: 60px;
                line-height: 60px;
                background: #161920;
                border-radius: 10px;
              }
              li:nth-child(odd) {
                width: 1280px;
                height: 60px;
                line-height: 60px;
                background: #1c1f26;
                border-radius: 10px;
              }
            }
          }
        }
        .pagination {
          width: 100%;
          height: 30px;
          // border: 1px solid red;
        }
      }
    }
  }
  .BlockListdelt {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 0;
    background: rgba(0, 0, 0, 0.7);
    width: 100%;
    height: 100%;
    overflow: auto;
    .BlockListdelt-W {
      width: 376px;
      height: 128px;
      background: #252931;
      border-radius: 10px 10px 10px 10px;

      position: absolute;
      z-index: 0 !important;
      // border: 1px solid red;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      .dtit {
        font-family: Alibaba PuHuiTi 3, Alibaba PuHuiTi 30;
        font-weight: 600;
        font-size: 20px;
        color: #ffffff;
        line-height: 28px;
        text-align: left;
        margin-left: 30px;
        margin-top: 26px;
      }
      .dcon {
        display: flex;
        margin-top: 20px;
        .close {
          width: 60px;
          height: 27px;
          line-height: 27px;
          cursor: pointer;
          font-family: Alibaba PuHuiTi 3, Alibaba PuHuiTi 30;
          font-weight: 400;
          font-size: 13px;
          color: #3cf6f0;
          margin-left: 216px;
        }
        .ok {
          width: 60px;
          height: 27px;
          line-height: 27px;
          background: #3cf6f0;
          text-align: center;
          border-radius: 5px 5px 5px 5px;
          cursor: pointer;
          font-family: Alibaba PuHuiTi 3, Alibaba PuHuiTi 30;
          font-weight: 400;
          font-size: 13px;
          color: #252931;
        }
      }
    }
  }
}
</style>
<style scoped>
/deep/.el-pagination.is-background .btn-prev {
  /* color: #151515; */
}
/deep/.el-icon-arrow-right:before {
  color: #fff !important;
}
/deep/.el-pagination__jump {
  color: #161920 !important;
  margin-left: 0px !important;
}
/deep/.el-pagination {
  display: flex;
  justify-content: right;
}
/deep/.el-pagination.is-background .btn-next {
  width: 32px;
  height: 32px;
  background: #151515;
  border-radius: 6px 6px 6px 6px;
}

/deep/ .el-pagination.is-background .btn-prev {
  width: 32px;
  height: 32px;
  background: #151515;
  border-radius: 6px 6px 6px 6px;
}
/deep/.el-el-pagination__jump {
  content: "page";

  font-size: 18px;
  font-family: HarmonyOS Sans-Medium, HarmonyOS Sans;
  font-weight: 500;
  color: #141414;
}
/deep/.el-pagination__editor.el-input {
  margin-left: -25px !important;
}
/deep/ .el-pagination__editor.el-input .el-input__inner {
  /* width: 32px;
  height: 32px; */

  /* background-size: cover; */
  text-align: center;
  border: none !important;
  font-family: Alibaba PuHuiTi 3, Alibaba PuHuiTi 30;
  font-weight: 400;
  font-size: 16px;
  color: rgba(255, 255, 255, 0.8);
  background: #161920;
  /* margin-left: 16px;
          margin-right: 16px; */
}
</style>
